import { InvoiceComparisonQuotes } from 'api/orders/schemas';
import { ComparisonQuoteBody } from './ComparisonQuoteBody';
import QuoteRebillModalWrapper from './QuoteRebillModalWrapper';

const ComparisonQuote = ({
  data,
  onOtherOptionsClick,
  onBackClick,
  onConsolidateServiceClick,
  onCheckout,
}: {
  data: InvoiceComparisonQuotes;
  onOtherOptionsClick?: () => void;
  onBackClick?: () => void;
  onConsolidateServiceClick?: () => void;
  onCheckout?: () => void;
}) => {
  return (
    <QuoteRebillModalWrapper
      type="comparison"
      onOtherOptionsClick={onOtherOptionsClick}
      onBackClick={() => {
        onBackClick?.();
      }}
      onConsolidateServiceClick={onConsolidateServiceClick}
      onCheckout={onCheckout}
    >
      <ComparisonQuoteBody data={data} />
    </QuoteRebillModalWrapper>
  );
};

export default ComparisonQuote;
